import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('GET_CATEGORY_GROUP'),
};



// WEBPACK FOOTER //
// ./src/app/common/category-group/categoryGroupActionKeys.js